/* eslint-disable no-underscore-dangle */
/** @typedef {import('../models/photo-entity').default} PhotoEntity */

import { PHOTO_IMAGE } from "../constants"

class ImageElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof ImageElement
   */
  static fromHtmlElement(htmlElement) {
    return new ImageElement(htmlElement.querySelector(PHOTO_IMAGE))
  }

  /**
   * Creates an instance of ImageElement.
   * @param {HTMLElement} element
   * @memberof ImageElement
   */
  constructor(element) {
    this.element = element

    this._onLoadCallbackList = []
    this.element.addEventListener("load", () => {
      this._onLoadCallbackList.forEach((callback) => callback())
    })
  }

  /**
   * @param {PhotoEntity} photo
   * @memberof ImageElement
   */
  apply(photo) {
    if (this.element.src !== photo.url) {
      this.element.src = photo.url
      this.element.dataset.photoId = photo.id
    }
  }

  /**
   * @param {function() : void} callback
   * @memberof ImageElement
   */
  onLoad(callback) {
    this._onLoadCallbackList.push(callback)
  }
}

export default ImageElement
